const EDIT_PRODUCT_QNA_DRAFT_PREFIX = 'admin:productQnaDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeAnswerValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

// 상품 문의 상세는 운영자가 다시 작성해야 하는 답변 값만 sessionStorage에 남긴다.
export const createProductQnaDraftPayload = ({ data = {} } = {}) => {
    return {
        data: {
            answer: normalizeAnswerValue(data.answer),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 답변 작성 흐름을 이어간다.
export const applyProductQnaDraft = ({ baseData = {}, draft }) => {
    if (!draft) {
        return {
            data: {
                ...baseData,
                answer: normalizeAnswerValue(baseData.answer),
            },
        }
    }

    const draftData = draft.data || {}

    return {
        data: {
            ...baseData,
            answer: draftData.answer === undefined
                ? normalizeAnswerValue(baseData.answer)
                : normalizeAnswerValue(draftData.answer),
        }
    }
}

export const createEditProductQnaDraftKey = (productQnaId) => `${EDIT_PRODUCT_QNA_DRAFT_PREFIX}${productQnaId}`

export const readProductQnaDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveProductQnaDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 답변 작성 흐름은 그대로 유지한다.
    }
}

export const clearProductQnaDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
